<template>
  <div id="app">
    <app-header v-if="!$authPage" :username="username"></app-header>
    <router-view id="rv"></router-view>

      <!-- FOOTER -->
    <footer class="footer">
        <div class="container">
            <div class="content has-text-centered">
                <p>
                    ChangeLogger ©2018
                </p>
            </div>
        </div>
    </footer>
    <!-- END FOOTER -->
  </div>
</template>
<script>
import AppHeader from "./components/AppHeader";
import HTTP from "./components/Http";


export default {
  name: "app",
  components: { AppHeader },
  data() {
    return {
     username: "a"
    };
  }
};
</script>

<style>
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  margin: 0;
}

* {
  box-sizing: border-box;
}

body {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  margin: 0;
}

#main {
  display: flex;
  flex: 1;
}

#main > aside {
  flex: 0 0 10vw;
  /* background: beige; */
}

/* #main>nav {
    order: -1;
} */

.footer {
  /* background: yellowgreen; */
  height: 10vh;
}

/* header, */
/* footer, */
/* article,
nav,
aside {
  padding: 1em;
} */

nav.navbar {
  padding: 0em;
}

.card {
  /* margin: 1em; */
}

/* .main{
  background-color: #fafafa;
  -webkit-box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1),
    0 0 0 1px rgba(10, 10, 10, 0.1);
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
} */
</style>



// WEBPACK FOOTER //
// src/App.vue